/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Videos_DescriptionInputs */

const en_settings_videos_description = /** @type {(inputs: Settings_Videos_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every rap video you've made. Download them any time.`)
};

/**
* | output |
* | --- |
* | "Every rap video you've made. Download them any time." |
*
* @param {Settings_Videos_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_videos_description = /** @type {((inputs?: Settings_Videos_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Videos_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_videos_description(inputs)
});
export { settings_videos_description as "settings.videos.description" }